import { render } from "./ui-update-entity-modal.vue?vue&type=template&id=62f21048&scoped=true&ts=true"
import script from "./ui-update-entity-modal.vue?vue&type=script&lang=ts"
export * from "./ui-update-entity-modal.vue?vue&type=script&lang=ts"

import "./ui-update-entity-modal.vue?vue&type=style&index=0&id=62f21048&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f21048"]])

export default __exports__